import React from 'react'
import { PayeeRoyalties } from '@Entities/statements/payee-royalties'
import { formatUSD } from '@App/helpers/format-currency'
import RightsholderRoyaltiesPayeeDownloadLink from '@Scenes/RightsholderScene/RightsholderRoyaltiesPayeeDownloadLink'
import '../index.scss'

interface SummaryTableProps {
    data: any[]
    viewStatements: (data: PayeeRoyalties) => void
    openStatusSidebar?: (data: PayeeRoyalties) => void
}

const SummaryTable = (props: SummaryTableProps) => {
    const { data, openStatusSidebar, viewStatements } = props

    return (
        <div className="royalties-table summary-table">
            <table>
                <tbody>
                    <tr>
                        <th>Publisher Number</th>
                        <th>Payee Name</th>
                        <th>Opening Balance</th>
                        <th>Royalties in Period</th>
                        <th>Payable Amount</th>
                        <th>Amount Paid</th>
                        <th>Closing Balance</th>
                        <th>Payment Status</th>
                        <th>Payee Activity</th>
                        <th>Statements</th>
                    </tr>
                    {data.map((row: PayeeRoyalties, index) => (
                        <tr key={index}>
                            <td>{row.publisherNumber}</td>
                            <td className="bold">{row.payeeName}</td>
                            <td>
                                <div className="currency">
                                    <p>{formatUSD(row.openingBalanceAmount)}</p>
                                </div>
                            </td>
                            <td>
                                <div className="currency">
                                    <p>{formatUSD(row.royaltiesAmount + row.adjustmentsAmount)}</p>
                                </div>
                            </td>
                            <td>
                                <div className="currency">
                                    <p>{formatUSD(row.payableBalanceAmount)}</p>
                                </div>
                            </td>
                            <td className="paid">
                                <div className="currency">
                                    <p>{formatUSD(row.paymentAmount)}</p>
                                </div>
                            </td>
                            <td>
                                <div className="currency">
                                    <p>{formatUSD(row.closingBalanceAmount)}</p>
                                </div>
                            </td>
                            <td>
                                <a className="small" onClick={() => openStatusSidebar && openStatusSidebar(row)}>
                                    {row.status}
                                </a>
                            </td>
                            <td>
                                <RightsholderRoyaltiesPayeeDownloadLink payeeRoyalties={row} useNewLink />
                            </td>
                            <td className="no-right-border">
                                <a className="small" onClick={() => viewStatements(row)}>
                                    View
                                </a>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default SummaryTable
